import { useAppDispatch } from "./hooks";
import { JSX, useContext, useEffect } from "react";
import App from "./App";
import { Button, MoonLoader } from "@hatch-digital-nl/bravilor-storybook";
import { Login } from "../common/svgs/Login";
import { AuthContext } from "react-oauth2-code-pkce";
import { setAuthToken } from "./rootReducer";
import { useNetworkStatus } from "../common/hooks/useNetworkStatus";
import { useLocalData } from "../common/hooks/useLocalData";

const AuthWrapper = (): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const { isOffline } = useNetworkStatus();
    const { hasSynchronizedData } = useLocalData();

    const authContext = useContext(AuthContext) || null;

    const token = authContext?.token;
    const logIn = authContext?.logIn || (() => {});
    const loginInProgress = authContext?.loginInProgress || false;

    useEffect(() => {
        if (token) {
            dispatch(setAuthToken(token));
        }
    }, [dispatch, token]);

    if (loginInProgress) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <MoonLoader />
            </div>
        );
    }

    if ((!!token && !loginInProgress) || hasSynchronizedData || isOffline) {
        return <App />;
    }

    return (
        <div className={"l-app__no-access"}>
            <h3>Please log in to continue</h3>
            <p>
                To access the features of this application, you need to log in
                first. You will be redirected to the login page. Once logged in,
                you can return to this page and continue using the app.
            </p>
            <Button
                variant={"primary"}
                backgroundColor={"#000"}
                onClick={() => logIn()}
            >
                <Login />
                Login
            </Button>
        </div>
    );
};

export default AuthWrapper;
